import { memo } from "react";

import { Box, Grid } from "@mui/material";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import TabsWrapperComponent from "../TabsWrapper";
import { EditorContextProvider } from "../context/editorContext";
import { useCPQEditorContainer } from "./CPQEditorContainer";
import { SelectedRowProvider } from "../TabsWrapper/SelectedRowContext";

// eslint-disable-next-line import/prefer-default-export
function CPQEditorComponent({
	contentGrid,
	rowActions,
	handleCKEditorSelectedTabId,
	buildNotesDialog,
	editorFullScreen
}) {
	const {
		leftContentExpanded,
	} = useCPQEditorContainer(contentGrid);

	return (
		<div className="quoteContentWrapper">
			<DndProvider backend={HTML5Backend}>
				<EditorContextProvider
					value={{
						contentGrid,
						rowActions,
						handleCKEditorSelectedTabId,
						buildNotesDialog,
						editorFullScreen
					}}
				>
					<Grid container spacing={2}>
						<Grid
							id="leftContent"
							item
							sx={{
								width: "100%",
								display: "block"
							}}
						>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									overflow: "auto"
								}}
							>
								<SelectedRowProvider>
									<TabsWrapperComponent expanded={leftContentExpanded} />
								</SelectedRowProvider>
							</Box>
						</Grid>
					</Grid>
				</EditorContextProvider>
			</DndProvider>
		</div>
	);
}

export default memo(CPQEditorComponent);
